<!DOCTYPE html>

<head>
  <meta charset="">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  
  
  <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.0.8/css/all.css">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
  <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css">
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" rel="stylesheet">

</head>






<section class="hero" >
  <div class="hero-content">
<br>
<br>
<br>


    <h1   >End-to-End Business Verification <br> Service that Delivers via API</h1>
    <p class="p-2" >
     FA Check APIs deliver end-to-end business verification service that integrate seamlessly into your platforms. With access to PAN, Aadhaar (where permitted), GST, CIN, DIN, bank account, and other verified sources, organizations can instantly validate identities and business information, reduce fraud, and maintain compliance. Built on a secure, encrypted infrastructure, FA Check ensures that sensitive data is transmitted safely without storage, giving businesses the confidence to verify at scale.
    </p>
    <a  routerLink="/website/contactus" class="btn-contact">Contact Us</a>
&nbsp;
&nbsp;
    <a  target="_blank" href="https://documenter.getpostman.com/view/32089063/2sAY547z6o" class="btn-docs">Get Docs <i class="fa fa-external-link" aria-hidden="true"></i></a>
    <br>
  <img  src="../../assets/Image/FA check home banner video (2).gif" alt="" srcset="">

  </div>
</section>



<section class="section-separator">
  <h2>Our Verification Services</h2>
</section>


<div class="services-tabs" id="servicesSection">
  <ul class="tab-header">
    <li [class.active]="activeTab === 'id'" (click)="setTab('id')">KYC Verifications (ID Based)</li>
    <li [class.active]="activeTab === 'ocr'" (click)="setTab('ocr')">KYC Verifications (OCR Based)</li>
    <li [class.active]="activeTab === 'other'" (click)="setTab('other')">Other Services</li>
  </ul>

  <div class="tab-content">
    <div *ngIf="activeTab === 'id'" class="tab-pane fade-in">
      <div class="services-grid">
  <!-- PAN Verification -->
  <div class="service-card">
    <img src="../../assets/pantopicon.png" alt="PAN Icon" class="service-icon">
    <h3>PAN Verification</h3>
    <p>PAN Card Verification enables you to check the validity of a Permanent Account Number in real time. Using the PAN Verification API, you can fetch important details such as card status, holder name, and date of birth, making it useful for financial, tax, and compliance purposes.</p>
  </div>

    <div class="service-card">
    <img src="../../assets/panchecks.png" alt="PAN Icon" class="service-icon">
    <h3>PAN Comprehensive</h3>
    <p>Authenticates PAN details with official records. Provides full validation of identity and tax compliance.</p>
  </div>

  <!-- Aadhaar Verification -->
  <div class="service-card">
    <img src="../../assets/aadhaar.png" alt="Aadhaar Icon" class="service-icon">
    <h3>Aadhaar Verification</h3>
    <p>Aadhaar Card Verification is the most reliable way to verify basic personal details. It allows you to validate information such as age group, state, gender, registered mobile number, and address, helping ensure accurate identity verification while maintaining data security.</p>
  </div>

  <div class="service-card">
    <img src="../../assets//aadhartopicon.png" alt="Aadhaar Icon" class="service-icon">
    <h3>Aadhaar OTP Based Verification</h3>
    <p>Quick and secure identity check using Aadhaar-linked mobile number. Ensures instant authentication through one-time password validation.</p>
  </div>

  <!-- GST Verification -->
  <div class="service-card">
    <img src="../../assets/gsttopicon.jpg" alt="GST Icon" class="service-icon">
    <h3>GST Verification</h3>
    <p>GST Verification helps in confirming the authenticity of a GST Identification Number (GSTIN). Using FA check, businesses can verify registration status and taxpayer details easily.</p>
  </div>

  <!-- Driving License Verification -->
  <div class="service-card">
    <img src="../../assets/drivinglicensetop.jpg" alt="Driving License Icon" class="service-icon">
    <h3>Driving License Verification</h3>
    <p>Driving License Verification checks whether a driver’s license is valid and authentic. It can also be used as an official form of identification.</p>
  </div>

  <!-- CIN Verification -->
  <div class="service-card">
    <img src="../../assets/cinicon.png" alt="CIN Icon" class="service-icon">
    <h3>CIN Verification</h3>
    <p>CIN (Corporate Identification Number) Verification validates the unique identification number assigned by the Registrar of Companies (ROC). It helps confirm company registration, legal status, and official corporate details in India</p>
  </div>

  <!-- RC Verification -->
  <div class="service-card">
    <img src="../../assets/rcverifyvehicle.jpg" alt="RC Icon" class="service-icon">
    <h3>RC Verification</h3>
    <p>RC (Registration Certificate) Verification confirms that a vehicle has been officially registered with the road transport authority. This process verifies the legitimacy and authenticity of the RC, helping validate vehicle ownership and registration details.</p>
  </div>

  <!-- Passport Verification -->
  <div class="service-card">
    <img src="../../assets/passportverification.png" alt="Passport Icon" class="service-icon">
    <h3>Passport Verification</h3>
    <p>A passport is an extremely important and valuable identity document. Passport verification ensures that the document is genuine and issued to the correct individual.</p>
  </div>

  <!-- FSSAI Verification -->
  <div class="service-card">
    <img src="../../assets/regulate.jpg" alt="FSSAI Icon" class="service-icon">
    <h3>FSSAI Verification</h3>
    <p>Validates food business licenses against official FSSAI records. Confirms authenticity of registration for compliance and trust</p>
  </div>

  <!-- Voter ID Verification -->
  <div class="service-card">
    <img src="../../assets/voteridchecks.png" alt="Voter ID Icon" class="service-icon">
    <h3>Voter ID Verification</h3>
    <p>Cross-checks voter ID details with government databases. Confirms identity and electoral eligibility of individuals.</p>
  </div>

  <!-- Bank Account Verification -->
  <div class="service-card">
    <img src="../../assets/bankaccount.png" alt="Bank Icon" class="service-icon">
    <h3>Bank Account Verification</h3>
    <p>Verifies account holder details directly with the bank. Ensures accuracy of account information for financial transactions.</p>
  </div>

  <div class="service-card">
    <img src="../../assets/optimize.png" alt="Bank Icon" class="service-icon">
    <h3>Bank Account Verification (Penny Drop)</h3>
    <p>Deposits a small amount to confirm account validity. Confirms ownership and operational status of the bank account.</p>
  </div>

</div>

    </div>

    <div *ngIf="activeTab === 'ocr'" class="tab-pane fade-in">
      <div class="services-grid2">
  <!-- PAN Verification -->
  <div class="service-card2">
    <img src="../../assets/ocr.png" alt="PAN Icon" class="service-icon2">
    <h3>PAN Advanced OCR</h3>
    <p>Our Pan Advanced OCR ensures accurate extraction of PAN card details, making verification seamless and reliable.</p>
  </div>

    <div class="service-card2">
    <img src="../../assets/ocrverify.png" alt="PAN Icon" class="service-icon2">
    <h3>GST Advanced OCR</h3>
    <p>With GST Advanced OCR, businesses can instantly capture and validate GST numbers from documents.</p>
  </div>

  <!-- Aadhaar Verification -->
  <div class="service-card2">
    <img src="../../assets/ocraadhar.png" alt="Aadhaar Icon" class="service-icon2">
    <h3>Passport Advanced OCR</h3>
    <p>Passport Advanced OCR reads and verifies passport details with high accuracy, supporting secure identity checks.</p>
  </div>

  <div class="service-card2">
    <img src="../../assets/voterid.jpg" alt="Aadhaar Icon" class="service-icon2">
    <h3>Voter ID Advanced OCR</h3>
    <p>Voter ID Advanced OCR extracts voter card data effortlessly, ensuring smooth authentication for digital platforms.</p>
  </div>

  <!-- GST Verification -->
  <div class="service-card2">
    <img src="../../assets/drivingverify.png" alt="GST Icon" class="service-icon2">
    <h3>Driving Licence Advanced OCR</h3>
    <p>Driving Licence Advanced OCR captures licence details with precision, enabling instant verification for service providers.</p>
  </div>

 
  
</div>
    </div>

    <div *ngIf="activeTab === 'other'" class="tab-pane fade-in">
      <div class="services-grid2">
  <!-- PAN Verification -->
  <div class="service-card2">
    <img src="../../assets/digitalsign.png" alt="PAN Icon" class="service-icon2">
    <h3>Document Signer </h3>
    <p>FA Check enables organizations to sign documents electronically with full legal validity. Each document is secured using a P12 certificate with SHA-256 hashing and RSA encryption, ensuring tamper-proof, verifiable approvals while eliminating paper-based workflows.</p>
  </div>

    <!-- <div class="service-card2">
    <img src="../../assets/digitalkycimage.png" alt="PAN Icon" class="service-icon2">
    <h3>Aadhaar Based Digital Signing</h3>
    <p>Aadhaar Based Digital Signing leverages UIDAI verification for instant, trusted e-signatures. It provides a seamless way to validate identity while signing documents online.</p>
  </div> -->

  <!-- Aadhaar Verification -->
  <div class="service-card2">
    <img src="../../assets/stamp.png" alt="Aadhaar Icon" class="service-icon2">
    <h3>eStamp</h3>
    <p>eStamp service allows legally recognized stamp duty payment without physical stamps. It ensures transparency, reduces fraud, and makes documentation hassle-free.</p>
  </div>

  

 
  
</div>
    </div>
  </div>
</div>


<section class="verification-section">
  
   
  <div class="intro-content">

    <img src="assets/toplog.png" style="width:200px" alt="" srcset="">
<br>
<br>

    <h2>Verification Made Simple with FA Check</h2>
    <p class="section-intro">
      Verification doesn’t have to be complicated.
     Our platform brings accuracy and  security together in one seamless experience.
      Build trust effortlessly while protecting your business from fraud and compliance risks.
    </p>
  </div>

  <!-- Box with logo + cards -->
  <div class="verification-box">
    <div class="logo-inside">
      <img src="../../assets/Image/icons8-protect-100.png" alt="FA Check Logo" class="logo-image">
    </div>

    <div class="verification-card">
      <img src="../../assets/Image/Confident User Onboarding - 23 .png" alt="User Onboarding" class="card-image">
      <div class="card-content">
        <h3>Confident User Onboarding</h3>
        <p>FA Check makes it easier to onboard real users by validating identities accurately at the first point of interaction.</p>
      </div>
    </div>

    <div class="verification-card">
      <img src="../../assets/Image/Continuous Trust Across User Journeys - 23 .png" alt="Trust Verification" class="card-image">
      <div class="card-content">
        <h3>Continuous Trust Across User Journeys</h3>
        <p>Verification doesn’t end at signup. Ongoing checks ensure trust is maintained as user information changes.</p>
      </div>
    </div>

    <div class="verification-card">
      <img src="../../assets/Image/Early Fraud Risk Identification - 23 .png" alt="Fraud Detection" class="card-image">
      <div class="card-content">
        <h3>Early Fraud Risk Identification</h3>
        <p>Spot warning signs before they turn into costly fraud.</p>
      </div>
    </div>

    <div class="verification-card">
      <img src="../../assets/Image/Regulatory Readiness Without Complexity - 23 .png" alt="Regulatory Compliance" class="card-image">
      <div class="card-content">
        <h3>Regulatory Readiness Without Complexity</h3>
        <p>Structured workflows and consistent checks keep you audit‑ready.</p>
      </div>
    </div>
  </div>
</section>






<section class="industries-section">
  <h2>Industries We Serve</h2>
  <p class="section-intro">
    FA Check delivers a reliable identity verification service for modern digital businesses. 
    Our platform simplifies onboarding while ensuring compliance and security. 
    Helping industries build trust with every verified interaction.
  </p>

  <div class="industries-grid">
    <!-- EdTech -->
    <div class="industry-card">
      <img src="../../assets/Image/icons8-education-94.png" alt="EdTech Icon" class="industry-icon">
      <h3>EdTech</h3>
      <p>Create a seamless digital learning experience by verifying students and educators quickly, so learning stays uninterrupted and secure.</p>
    </div>

    <!-- Insurance -->
    <div class="industry-card">
      <img src="../../assets/Image/icons8-insurance-94.png" alt="Insurance Icon" class="industry-icon">
      <h3>Insurance</h3>
      <p>Onboard customers in under 60 seconds with fast, compliant, and secure verification that reduces drop-offs and improves customer trust.</p>
    </div>

    <!-- Logistics & eCommerce -->
    <div class="industry-card">
      <img src="../../assets/Image/icons8-shopping-cart-94.png" alt="Logistics Icon" class="industry-icon">
      <h3>Logistics & eCommerce</h3>
      <p>Ensure safe and reliable operations by instantly verifying sellers, delivery partners, and customers, building trust at every step of the journey.</p>
    </div>

    <!-- Industries -->
    <div class="industry-card">
      <img src="../../assets/Image/icons8-factory-94.png" alt="Industry Icon" class="industry-icon">
      <h3>Industries</h3>
      <p>Enable smooth business operations by validating ownership, identities, and critical data that industries rely on to function efficiently and transparently.</p>
    </div>

    <!-- Banks & NBFCs -->
    <div class="industry-card">
      <img src="../../assets/Image/icons8-building-with-columns-94.png" alt="Bank Icon" class="industry-icon">
      <h3>Banks & NBFCs</h3>
      <p>Minimise fraud risks while boosting revenue and customer conversion through accurate, compliant, and real-time identity verification</p>
    </div>

    <!-- Marketplaces -->
    <div class="industry-card">
      <img src="../../assets/Image/icons8-market-94.png" alt="Marketplace Icon" class="industry-icon">
      <h3>Marketplaces</h3>
      <p>Simplify registrations and maintain compliant marketplace operations by verifying users, vendors, and partners with confidence.</p>
    </div>

    <!-- Finance -->
    <div class="industry-card">
      <img src="../../assets/Image/icons8-cash-in-hand-94.png" alt="Finance Icon" class="industry-icon">
      <h3>Finance</h3>
      <p>FA Check enables financial institutions to onboard customers securely with fast and compliant identity verification.We empower finance businesses to build trust, protect data, and deliver seamless digital financial services.</p>
    </div>

    <!-- Clients -->
    <div class="industry-card">
      <img src="../../assets/Image/icons8-client-94.png" alt="Clients Icon" class="industry-icon">
      <h3>Clients</h3>
      <p>Turn casual users into verified clients by creating trust-first digital experiences from the very first interaction.</p>
    </div>
  </div>
</section>


<section class="process-section">
  <h2>How FA Check Verifies Users Instantly?</h2>
  <p class="section-intro">
    FA Check is designed to make identity verification fast, secure, and effortless. 
    The process runs entirely in the background, delivering accurate results within seconds.
  </p>

<div class="process-flow">
  <div class="process-card"     >
    <div class="step-number">1</div>
    <div class="process-icon">⚡</div>
    <h3>Instant API Response</h3>
    <p>Once a request is submitted, FA Check processes the data immediately and returns results in real time with no waiting, no delays.</p>
  </div>

  <div class="process-card">
    <div class="step-number">2</div>
    <div class="process-icon">🔗</div>
    <h3>Seamless Integration</h3>
    <p>The API is built to plug smoothly into your existing system. Whether you’re scaling a platform or launching a new service, integration is quick and developer-friendly.</p>
  </div>

  <div class="process-card">
    <div class="step-number">3</div>
    <div class="process-icon">🛡️</div>
    <h3>Real-Time Identity Verification</h3>
    <p>FA Check validates user details instantly using trusted verification methods, ensuring authenticity while preventing fraud.</p>
  </div>

  <div class="process-card">
    <div class="step-number">4</div>
    <div class="process-icon">✅</div>
    <h3>Verified Successfully</h3>
    <p>When the verification is complete, you receive a clear confirmation status, helping you approve users with confidence and speed.</p>
  </div>
</div>



</section>

<section class="cta-section">
  <div class="cta-content">
    <h2>Are fake identities slipping through your KYC checks? Stop them with FA Check.</h2>
    <button class="cta-button"  href="/website/contactus" > <a href="/website/contactus"  style="text-decoration: none;color:#fffbff ;"  >Reach Us</a> </button>
  </div>
</section>
<br>
<br>
<br>


<script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/js/bootstrap.bundle.min.js"></script>
